module.exports = __webpack_public_path__ + "img/seedpaper-white.1e5bb438.jpg";